!function(){
  function declareSKU(internalNameOfTarget, skuPatternArray){
    BOLD.options.app.on('option_products_loaded', function(){   //if (internalNameOfTarget == 'mountSKUs' ) { window.intName = internalNameOfTarget; }
      var option_products = BOLD.options.app.optionProducts;
      var containsSkuProduct = false;
      for(var o=0; o<option_products.length; o++){
        var option_product = option_products[o];  

        if(!option_product.getOptionByInternalName){
          BOLD.BMS.extendOptions(option_product);
        }

        if(option_product.getOptionByInternalName(internalNameOfTarget)){
          containsSkuProduct = true;
        }
      }
      if(containsSkuProduct){
        new SKUrule(internalNameOfTarget, skuPatternArray);
      }
    })
  }
  /* ************************************************************
  MOUNTS
  ************************************************************ */
  var kioskSKUpart = {
    name:'kiosk',
    codes:{
      'CN':'CounterFixed',
      'CNTW':'CounterTwist', // [Counter Twist](Originally 'C'), versus new [Counter Fixed]('CN'), CN not yet handled
      'F':'Floor',
      'S':'Surface',
      'W':'Wall',
      'FLP':'Flip',
      'P':'Picture',
      'T': 'Tabletop'
    },
    input_name:'Kiosk Type',
    can_disable_choices:false
  }  
  
  var colourSKUpart = {
    name:'color',
    codes:{
      'W':'White',
      'B':'Black'
    },
    input_name:'Color',
    can_disable_choices:false
  }

  //swivelSKUpart
  var swivelSKUpart = {
    name:'swivel',
    codes:{
      '':'Fixed',
      'TW':'Twist'
    },
    input_name:'counterSwivel',
    can_disable_choices:false
  }

  
  var mountStyleSKUpart = { 
    name:'style',
    codes:{
      'B':'Basic', 
      'MD':['Pro','Pro - Dual Charge'], //originally, was just 'Pro'
      'SD':'Smart'
    },
    input_name:'Mount Style',
    can_disable_choices:true
  }
   
  var pinSKUpart = {
    name:'pins',
    codes:{
      'B':['0 pin basic'],
      'BC':['Barrel Connector'],
      'SCP':['6pin', 'Standard Power', 'Dual ChargeX'], //Added Dual Charge here temporarily on 19Apr24 due to 'Not Valid' error
      'DCP':['12pin', 'Dual Charge'] //,
    },
    input_name:'Pins',
    can_disable_choices:true
  }
  
  declareSKU('mountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, kioskSKUpart]); 
  declareSKU('floormountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'F']);
  declareSKU('countermountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'CN']);
  declareSKU('surfacemountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'S']);
  declareSKU('flipmountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'FLP']);
  declareSKU('picturemountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'P']);
  declareSKU('wallmountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'W']);
  declareSKU('tabletopmountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'T']);
  declareSKU('countertwistmountSKUs', ['G40', mountStyleSKUpart, '-', pinSKUpart, '-', colourSKUpart, 'CNTW']);

  /* ************************************************************
  HEAD UNITS
  ************************************************************ */
  var headSkuPart = {
    name:'head',
    codes:{
      'K25HU':'K Head Unit',
      'P40HU':'P Head',    
      'P40HU':'P Head Unit',
      'H40HU':'H Head'
    },
    input_name:'Head Unit',
    can_disable_choices:true
  }

/*
current Tablet Options:

iPad 10th Gen 10.9" 
iPad 8th & 9th Gen 10.2"
iPad 7th Gen 10.2"
iPad 5th & 6th Gen 9.7"
iPad Air 11"
iPad Air 10.9" 4th & 5th Gen   
iPad Pro & Air 10.5"
iPad Air 13"
iPad Pro 13”
iPad Pro 12.9" 4th, 5th & 6th Gen
iPad Pro 12.9" 3rd Gen
iPad Pro 12.9" 1st & 2nd Gen
iPad Pro 11" 5th Gen
iPad Pro 11" 2nd, 3rd & 4th Gen
iPad Pro 11" 1st Gen
--------------------------------
Samsung Tab S6 10.5" & Lite 10.4"
Samsung Tab A 10.1" (2019)
-------------------------------
Microsoft Surface Pro 5 6 & 7 12.9"
*/

  var headTabletSkuPart = {
    name:'tablet',
    codes:{
      'H40HU':{
        'A109': ['iPad Air 10.9" 4th & 5th Gen'],  
        'I109': ['iPad 10th & 11th Gen 10.9"'],
        'I10':  ['iPad 8th & 9th Gen 10.2"','iPad 7th Gen 10.2"', 'iPad 7th 8th & 9th Gen 10.2"'],
        'P11':  ['iPad Pro 11" 1st Gen'],
        'P112': ['iPad Pro 11" 2nd 3rd & 4th Gen'],
        'I':    ['iPad 5th & 6th Gen 9.7"'],
        'P10':  ['iPad Pro & Air 10.5"'],
        'S6':   ['Samsung Tab S6 10.5" & Lite 10.4"'],
        'A10':  ['Samsung Tab A 10.1" (2019)'],
        'A11':  ['iPad 1st & 2nd Gen Air 11"'],
        'P115': ['iPad Pro 11" 5th Gen']
      },
      'K25HU':{
        'A1':   ['iPad 5th & 6th Gen 9.7"'],
        'TA102':['Samsung Tab A 10.1" (2019)']
      },
      'P40HU':{ 
        'P':    ['iPad Pro 12.9" 1st & 2nd Gen'],
        'P3':   ['iPad Pro 12.9" 3rd Gen'],                 
        'P4':   ['iPad Pro 12.9" 4th 5th & 6th Gen'],   
        'MS':   ['Microsoft Surface Pro 5 6 & 7 12.9"'],
        'A13':  ['iPad 1st & 2nd Gen Air 13"'],
        'P13':  ['iPad Pro 13"']
      }
    },
    using:'head',
    input_name:'Tablet Type',
    can_disable_choices:false
  }  

  var styleSKUpart = {
    name:'style',
    codes:{
      'B':'Basic',
      'P':['Pro'],
      'MD':['Pro2'],
      //'SD':'Smart',
      'S':'Smart',
      'H':'Handheld'
    },
    input_name:'Mount Style',
    can_disable_choices:true
  }
  
  var styleSKUpartPlusProDualCharge = {
    name:'style',
    codes:{
      'B':'Basic',
      'P':['Pro','Pro - Dual Charge'],
      //'SD':'Smart',
      'S':'Smart',
      'H':'Handheld'
    },
    input_name:'Mount Style',
    can_disable_choices:true
  }

  declareSKU('headSKUs', [headSkuPart,styleSKUpart,'-',colourSKUpart,headTabletSkuPart]);
  
  declareSKU('headplusprodualSKUs', [headSkuPart,styleSKUpartPlusProDualCharge,'-',colourSKUpart,headTabletSkuPart]);

  /* ************************************************************
  HANDHELD UNITS
  ************************************************************ */
  
   var handheldheadTabletSkuPart = {
    name:'tablet',
    codes:{
      'H40HU':{
        'A10':  ['Samsung Tab A 10.1" (2019)'],
        'A109': ['iPad Air 10.9" 4th & 5th Gen'],
        'I':    ['iPad 5th & 6th Gen 9.7"'],
        'I10':  ['iPad 8th & 9th Gen 10.2"', 'iPad 7th Gen 10.2"'],
        'I109': ['iPad 10th & 11th Gen 10.9"'],
        'P10':  ['iPad Pro & Air 10.5"'],
        'P11':  ['iPad Pro 11" 1st Gen'],
        'P112': ['iPad Pro 11" 2nd, 3rd & 4th Gen'],
        'S6':   ['Samsung Tab S6 10.5" & Lite 10.4"'],
        'A11':  ['iPad 1st & 2nd Gen Air 11"'],
        'P115': ['iPad Pro 11" 5th Gen']
      },
      'P40HU':{
        'MS':   ['Microsoft Surface Pro 5 6 & 7 12.9"'],
        'P':    ['iPad Pro 12.9" 1st & 2nd Gen'],
        'P3':   ['iPad Pro 12.9" 3rd Gen'], 
        'P4':   ['iPad Pro 12.9" 4th, 5th & 6th Gen'],  
        'A13':  ['iPad 1st & 2nd Gen Air 13"'],
        'P13':  ['iPad Pro 13"']
      } 
    },
    using:'head',
    input_name:'Tablet Type',
    can_disable_choices:false
  }

  var handheldheadSkuPart = {
    name:'head',
    codes:{
      'P40HU':'P Head Unit',
      'H40HU':'H Head Unit',
    },
    input_name:'Head Unit',
    can_disable_choices:true
  }

  declareSKU('handheldheadSKUs', [handheldheadSkuPart,'H','-',colourSKUpart,handheldheadTabletSkuPart]);

  /* ************************************************************
  VESAHEAD UNITS
  ************************************************************ */
    
 var vesaheadTabletSkuPart = {
    name:'tablet',
    codes:{
      'H40HU':{
        'A10':  ['Samsung Tab A 10.1" (2019)'],
        'A109': ['iPad Air 10.9" 4th & 5th Gen'],
        'I':    ['iPad 5th & 6th Gen 9.7"'],
        'I10':  ['iPad 8th & 9th Gen 10.2"', 'iPad 7th Gen 10.2"'],
        'I109': ['iPad 10th & 11th Gen 10.9"'],
        'P10':  ['iPad Pro & Air 10.5"'],
        'P11':  ['iPad Pro 11" 1st Gen'],
        'P112': ['iPad Pro 11" 2nd, 3rd & 4th Gen'],
        'S6':   ['Samsung Tab S6 10.5" & Lite 10.4"'],
        'A11':  ['iPad 1st & 2nd Gen Air 11"'],
        'P115': ['iPad Pro 11" 5th Gen']
      },
      'P40HU':{
        'MS':   ['Microsoft Surface Pro 5 6 & 7 12.9"'],
        'P':    ['iPad Pro 12.9" 1st & 2nd Gen'],
        'P3':   ['iPad Pro 12.9" 3rd Gen'], 
        'P4':   ['iPad Pro 12.9" 4th, 5th & 6th Gen'],
        'A13':  ['iPad 1st & 2nd Gen Air 13"'],
        'P13':  ['iPad Pro 13"']
      } 
    },
    using:'head',
    input_name:'Tablet Type',
    can_disable_choices:false
  }

  var vesaheadSkuPart = {
    name:'head',
    codes:{
      'P40HU':'P Head Unit',
      'H40HU':'H Head Unit',
    },
    input_name:'Head Unit',
    can_disable_choices:true //DANGER: this can cause loop within script when value is 'true'
  }
  
  declareSKU('vesaheadSKUs', [vesaheadSkuPart,'V','-',colourSKUpart,vesaheadTabletSkuPart]);
  
  /* ************************************************************
  FACEPLATES
  ************************************************************ */
  var faceSKUpart = {
    codes:{
      //'H30A':'H Head Unit',
      'H30A':['H Head Unit', 'H Head'],
      'K25A':'K Head Unit',
      'P30A':'P Head Unit',
    },
    name:'head',
    input_name:'Head Unit',
    can_disable_choices:false
  }

  var faceOptionsSKUpart = {
    codes:{
      'BL':['Blank','Closed', 'Blank (No Holes)'],
      'BL-WC':['Blank, Sealed'],
      'CH':['Camera + Home', 'Open'],
      'CP':['Camera + Pinhole', 'Camera + Pinhole Home'],
      'f':['Camera Only'], //is 'f' really a thing?
      'CO':['Camera Only'],
      'PO':['Pinhole Only', 'Pinhole Home'],
      'HO':['Home Only', 'Home Button'],
      'CH-WC':['Camera + Home, Sealed'],
      'C':['Camera'],
      'C-WC':['Camera, Sealed']
    },
    name:'faceOptions',
    input_name:'Face Plate',
    can_disable_choices:true
  }

    var faceTabletSkuPart = {
    codes:{
      'H30A':{
        'P10':  ['iPad Pro & Air 10.5"'],
        'P97':  ['iPad 5th & 6th Gen 9.7"'],
        'P11':  ['iPad Pro 11" 1st Gen', 'iPad Pro 11" 2nd 3rd & 4th Gen'], 
        'I10':  ['iPad 7th Gen 10.2"', 'iPad 8th & 9th Gen 10.2"'],
        'S6':   ['Samsung Tab S6 10.5" & Lite 10.4"'],
        'A10':  ['Samsung Tab A 10.1" (2019)'],
        'A109': ['iPad Air 10.9" 4th & 5th Gen'],
        'I109': ['iPad 10th & 11th Gen 10.9"'],
        'AP11': ['iPad 1st & 2nd Gen Air 11"', 'iPad Pro 11" 5th Gen'] 
      },
      'K25A':{
        'A':    ['iPad 5th & 6th Gen 9.7"'],
        'TA102':['Samsung Tab A 10.1" (2019)']
      },
      'P30A':{
        'P':    ['iPad Pro 12.9" 1st & 2nd Gen'],
        'P3':   ['iPad Pro 12.9" 3rd Gen', 'iPad Pro 12.9" 4th 5th & 6th Gen'], 
        'MS':   ['Microsoft Surface Pro 5 6 & 7 12.9"'],
        'A13':  ['iPad 1st & 2nd Gen Air 13"'],
        'P13':  ['iPad Pro 13"']   
      },
    },
    name:'tablet',
    input_name:'Tablet Type',
    using:'head',
    can_disable_choices:false
  }

  var faceOptionsSKUpart = {
    codes:{
      'BL':['Blank','Closed', 'Blank (No Holes)'],
      'BL-WC':['Blank, Sealed'],
      'CH':['Camera + Home', 'Open'],
      'CP':['Camera + Pinhole', 'Camera + Pinhole Home'],
      'f':['Camera Only'], //is 'f' really a thing?
      'CO':['Camera Only'],
      'PO':['Pinhole Only', 'Pinhole Home'],
      'HO':['Home Only', 'Home Button'],
      'CH-WC':['Camera + Home, Sealed'],
      'C':['Camera'],
      'C-WC':['Camera, Sealed']
    },
    name:'faceOptions',
    input_name:'Face Plate',
    can_disable_choices:true
  }

  BOLD.options.app.on('option_products_loaded', function(evt){
    var internalNameOfTarget = 'faceSKUs'
    var containsSkuProduct = false;
    var internalNameOfHeadUnits = 'headSKUs'
    var containsHeadUnit = false;

    var option_products = evt.data.option_products;
    for(var o=0; o<option_products.length; o++){
      var option_product = option_products[o];

      if(!option_product.getOptionByInternalName){
        BOLD.BMS.extendOptions(option_product);
      }

      if(option_product.getOptionByInternalName(internalNameOfTarget)){
        containsSkuProduct = true;
      }
      if(option_product.getOptionByInternalName(internalNameOfHeadUnits)){
        containsHeadUnit = true;
      }
    }
    if(!containsHeadUnit){
      faceSKUpart.can_disable_choices = true;
    }
    if(containsSkuProduct){
      var FaceSku = new SKUrule(internalNameOfTarget, [faceSKUpart,'-',colourSKUpart,'FP','-',faceTabletSkuPart,faceOptionsSKUpart]);
    }
  })

  /* ************************************************************
  BRANDING
  ************************************************************ */
  var brandKioskSKUpart = JSON.parse(JSON.stringify(kioskSKUpart))
  brandKioskSKUpart.optional = true

  var brandPositionSkuPart = {
    codes:{
      'BD':'Backdrop',
      'FP':['Faceplate', 'Full Faceplate'],
      'F':'Floor Front',
      'FL':'Faceplate Logo'
    },
    name:'brandPosition',
    input_name:'brandingPosition',
    can_disable_choices:true
  }
  var rushShippingSkuPart = {
    codes:{
      '':'Regular',
      '-1R':'1-Day Rush Production',
      '-2R':'2-Day Rush Production'
    },
    name:'rush',
    input_name:'Rush',
    can_disable_choices:true

  }
  
  declareSKU('brandingSKUs', ['G2XG','-',brandPositionSkuPart,brandKioskSKUpart,rushShippingSkuPart]);

  /* ************************************************************
  GRAPHIC ACCESSORIES
  ************************************************************ */
  var accessoryColourSKUpart = JSON.parse(JSON.stringify(colourSKUpart))
  accessoryColourSKUpart.optional = true

  graphicColourSKUpart = JSON.parse(JSON.stringify(colourSKUpart));
  graphicColourSKUpart.optional = true;
  graphicColourSKUpart.false_positive_correction = true;

  var graphicAccessorySkuPart = {
    codes:{
      'BC':'Backdrop Case',
      'PC':'Panel Mounting Clips'
    },
    name:'accessory',
    input_name:'graphicAccessoriesSelection',
    can_disable_choices:true
  }
  declareSKU('graphicAccessorySKUs', ['G2XGA','-',graphicColourSKUpart,graphicAccessorySkuPart,brandKioskSKUpart]);

  /* ************************************************************
  ACCESSORIES: MOUNTS
  ************************************************************ */
  var accessoryHeadSkuPart = {
    codes:{
      '2':['K Head Unit'],
      '3':['H Head Unit', 'P Head Unit']
    },
    name:'head',
    input_name:'Head Unit'
  }

  var mountAccessoryCodes = {
    'BP':'Floor Base',
    'CB':'Compact Base',
    'FHM':'Headphone Mount',
    'PB':'Printer Bracket',
    'CAX':'Apple Extension Cable',
    'BH':'Brochure Holder',
    'CK':'Cleaning Kit',
    'DLH':'Double Literature Holder',
    'WB':'Wheeled Base',
    'ATAF':'ATA Case',
    'NB':'No Base',
    'TB': 'Tabletop Base'
  }
  var mountAccessorySkuPart = {
    codes: mountAccessoryCodes,
    name:'accessory',
    input_name:'mountAccessories',
    can_disable_choices:true
  }
  var mountAccessoryKioskSKUpart = {
    name:'kiosk',
    codes:{
      '-F':'Floor',
      '-SCFLP':['Surface','CounterFixed','Flip']
    },
    input_name:'Kiosk Type',
    can_disable_choices:false,
    optional:true
  }
  var accessoryNoColourSkuPart = {}

  /* ************************************************************
  ACCESSORIES: BASES
  ************************************************************ */
  var floorMountAccessorySkuPart = {
    codes: mountAccessoryCodes,
    name:'base',
    input_name:'floorMountBase',
    can_disable_choices:false
  }
  var counterMountAccessorySkuPart = {
    codes: mountAccessoryCodes,
    name:'base',
    input_name:'counterMountBase',
    can_disable_choices:false
  }
  var tabletopMountAccessorySkuPart = {
    codes: mountAccessoryCodes,
    name:'base',
    input_name:'tabletopMountBase',
    can_disable_choices:false
  }

  
  var swivelAccessoryCodes = {
    'FX':'Fixed',
    'SW':'Swivel'
  }
  
  var counterSwivelAccessorySkuPart = {
    codes: swivelAccessoryCodes,
    name:'swivel',
    input_name:'counterSwivel',
    can_disable_choices:false
  }

  declareSKU('floorMountBaseSKU', ['G','2X','A','-',accessoryColourSKUpart,floorMountAccessorySkuPart] )
  declareSKU('counterMountBaseSKU', ['G','2X','A','-',accessoryColourSKUpart,counterMountAccessorySkuPart] )
  declareSKU('tabletopMountBaseSKU', ['G','2X','A','-',accessoryColourSKUpart,tabletopMountAccessorySkuPart] )
  
}()
